import React from "react";
import { XIcon } from "lucide-react";
import { problems } from "../../data/content";
export function Problems() {
  return <section className="bg-ivory py-16 md:py-24" data-id="element-165" data-mp="17zifit7powpf">
      <div className="mx-auto max-w-wrap px-5 md:px-8" data-id="element-166" data-mp="1czwoqel1ucp1">
        <h2 className="heading mx-auto max-w-[860px] text-center text-[38px] text-forest md:text-[58px]" data-id="element-167" data-mp="1d0fxp5sq1qqx">
          You want to make bags. <span className="text-sand-deep" data-id="element-168" data-mp="1hwn38xh7h08c">But something always gets in the way.</span>
        </h2>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 md:mt-14 lg:grid-cols-3 lg:gap-5" data-id="element-169" data-mp="k9ehd1dalp5t">
          {problems.map(p => <article key={p} className="flex items-start gap-4 rounded-2xl border border-line bg-cream p-6 shadow-[0_4px_14px_rgba(48,74,59,0.06)]" data-id="element-170" data-mp="u8vhl39rzaue">
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#F6E5DF] text-[#A2452B]" data-id="element-171" data-mp="1kzrihepoh6l">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-172" data-mp="6ijec5ph62a5" />
              </span>
              <p className="m-0 text-[17px] font-medium leading-snug text-charcoal" data-id="element-173" data-mp="67iflri78t64">{p}</p>
            </article>)}
        </div>
        <p className="heading mt-12 text-center text-[30px] text-forest md:text-[40px]" data-id="element-174" data-mp="18xochkxdjtt">
          What if your next bag <span className="text-sand-deep" data-id="element-175" data-mp="3skqo9iu64qiu">was already planned?</span>
        </p>
      </div>
    </section>;
}